// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"062b12e9","447":"7fcc09e8"}[chunkId] + ".chunk.css";
};